<div class="search-control-group">
  <div #container class="segmented-control">
    <div class="indicator" [ngStyle]="indicatorStyle"></div>
    @for (option of options; track option; let i = $index) {
      <div
        class="segment"
        [class.selected]="selectedOption === option.label"
        (click)="onClickSegment(option.label)">
        <i [class]="option.icon" class="icon"></i>
        <p style="margin-bottom: 0; text-wrap: nowrap">{{ option.label }}</p>
      </div>
    }
  </div>

  <div style="display: flex; flex-direction: row; gap: 10px; flex-grow: 1">
    @if (selectedOption === 'Address') {
      <input [(ngModel)]="search"
        typeaheadOptionField="SitusStreet"
        [typeahead]="parcels"
        [typeaheadAsync]="true"
        [typeaheadOptionsLimit]="5"
        [optionsListTemplate]="customListTemplate"
        (typeaheadOnSelect)="handleTypeheadOnSelect($event)"
        class="form-control custom-menu"
        placeholder="123 Main Street, Los Angeles CA, 90019">
    }
    @if (selectedOption === 'AIN') {
      <input class="form-control custom-menu" placeholder="001-002-003" [formControl]="ainFormControl" appNumericSplitter [splitterType]="SplitterType.AIN">
    }

    <button class="btn btn-primary btn-assessor" style="white-space: nowrap" (click)="onClickAdd()" [disabled]="reachedParcelLimit">Add</button>
  </div>
</div>

<ng-template #customListTemplate let-matches="matches" let-query="query" let-typeaheadTemplateMethods>
  <ul class="custom-list-group">
    @for (match of matches; track match) {
      <li
        class="custom-list-group-item"
        [class.active]="typeaheadTemplateMethods.isActive(match)"
        (click)="typeaheadTemplateMethods.selectMatch(match, $event)"
        (mouseenter)="typeaheadTemplateMethods.selectActive(match)"
        >
        {{ match.item.SitusStreet + ', ' +  match.item.SitusCity + ', ' +  match.item.SitusZipCode }}
      </li>
    }
  </ul>
</ng-template>
